import {CREATE_MYNETWORK_SUCCESS, CREATE_MYNETWORK_REQUEST, CREATE_MYNETWORK_FAILURE} from './myNetworkTypes'

const initialState = {
  loading: true,
  data: [],
  errorMsg: '',
};

const myNetworkReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_MYNETWORK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_MYNETWORK_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: '',
      };
    case CREATE_MYNETWORK_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default myNetworkReducer